const linkIsExternal = (uri: string) => {
  return uri.includes("https://") || uri.includes("http://") || uri.includes("mailto:") || uri.includes("tel:");
};

const linkIsFromYoutube = (uri: string) => {
  return uri.includes("youtube.com/embed");
};

const linkIsFromVimeo = (uri: string) => {
  return uri.includes("player.vimeo.com/video");
};

export const linkOriginResolver = {
  linkIsExternal,
  linkIsFromYoutube,
  linkIsFromVimeo,
};
